const getID = (node) => {
    const nodeAny = node;
    return nodeAny.id == undefined
        ? `${node.getSourceFile().fileName}:${node.getStart()}:${node.getWidth()}`
        : nodeAny.id;
};
export const nodeKey = (node) => `${getID(node)}`;

//# sourceMappingURL=nodeKey.js.map
